import React, { useState, useEffect } from "react";
import { FaChevronUp, FaTimes } from "react-icons/fa";
import job from "../Assets/jonoprtunity.png";
import ConfirmModal from "./ConfirmModal";
import axios from "axios";
import BASE_URL from "../utils/Urls";

const UserPopup = ({ onClose, onCreated }) => {
  const [showMain, setShowMain] = useState(true);
  const [showConfirm, setShowConfirm] = useState(false);

  const [userId, setUserId] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [onboardingFee, setOnboardingFee] = useState("");
  const [group, setGroup] = useState("");
  const [groups, setGroups] = useState([]);
  const [purpose, setPurpose] = useState("");
  const [mainEmployeeCode, setMainEmployeeCode] = useState("");
  const [error, setError] = useState("");
  const [groupsError, setGroupsError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/groups/`);
        if (res.data?.status === "success") {
          setGroups(res.data.result);
        } else {
          setGroupsError("⚠️ Could not load groups. Please close and reopen this form.");
        }
      } catch (err) {
        console.error("❌ Failed to fetch groups:", err.message);
        setGroupsError("⚠️ Could not load groups. Please check your connection and reopen this form.");
      }
    };
    fetchGroups();
  }, []);

  const handleCreateAccount = () => {
    setError("");
    const id = userId.trim();
    const phone = phoneNumber.trim();
    const mail = email.trim().toLowerCase();
    const fee = Number(onboardingFee);

    if (!id) return setError("⚠️ Please enter a user ID");
    if (!phone) return setError("⚠️ Please enter a phone number");
    if (!/^[5-9]\d{9}$/.test(phone))
      return setError("⚠️ Phone number must be 10 digits and start with a digit 5-9");
    if (!mail) return setError("⚠️ Please enter an email");
    if (!/^[^\s@]+@gmail\.com$/.test(mail))
      return setError("⚠️ Invalid email — only Gmail (@gmail.com) addresses are allowed, with no spaces");
    if (!group) return setError("⚠️ Please select a group before creating an account");
    if (!purpose) return setError("⚠️ Please select a purpose before creating an account");
    if (!onboardingFee.toString().trim() || isNaN(fee) || fee < 99)
      return setError("⚠️ Onboarding fee must be a number and at least 99");

    setShowConfirm(true);
  };

  const handleConfirmYes = async () => {
    setSubmitting(true);
    try {
      const response = await axios.post(`${BASE_URL}/users/admin`, {
        user_id: userId.trim(),
        phone_number: phoneNumber.trim(),
        email: email.trim().toLowerCase(),
        onboarding_fee: Number(onboardingFee),
        group,
        purpose,
        main_employee_code: mainEmployeeCode.trim(),
      });

      console.log("✅ User created:", response.data);
      alert("✅ User Created Successfully, thank you Admin");
      onCreated?.();
      handleCloseAll();
    } catch (err) {
      const serverMsg =
        err.response?.data?.message ||
        err.response?.data?.error ||
        (err.response
          ? `❌ Failed to create user (HTTP ${err.response.status})`
          : `❌ Network error: ${err.message}`);
      setShowConfirm(false);
      setError(serverMsg);
    } finally {
      setSubmitting(false);
    }
  };

  const handleCloseAll = () => {
    setShowMain(false);
    setShowConfirm(false);
    onClose?.();
  };

  return (
    <>
      {showMain && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div
            className="relative rounded-3xl shadow-xl w-full max-w-md mt-5 flex flex-col"
            style={{
              backgroundImage: `url(${job})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <button
              onClick={onClose}
              className="absolute top-4 right-4 bg-red-500 hover:bg-red-600 text-white p-2 rounded-sm z-10 transition-colors"
            >
              <FaTimes className="w-5 h-5" />
            </button>

            <div className="relative p-6 my-10 flex-1 max-h-[80vh] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-transparent">
              {error && (
                <div
                  role="alert"
                  className="mb-4 rounded-xl border border-red-400 bg-red-600/90 px-4 py-3 text-sm font-semibold text-white shadow"
                >
                  {error}
                </div>
              )}
              <div className="space-y-4 mb-6">
                <div>
                  <label className="block text-white text-sm font-semibold mb-1">USER ID</label>
                  <div className="border border-white rounded-xl px-4 py-3 bg-white/10 backdrop-blur-md">
                    <input
                      type="text"
                      value={userId}
                      onChange={(e) => {
                        setUserId(e.target.value);
                        setError("");
                      }}
                      className="w-full bg-transparent border-none text-white focus:outline-none placeholder-gray-300"
                      placeholder="Enter user ID"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-white text-sm font-semibold mb-1">Ph number</label>
                  <div className="border border-white rounded-xl px-4 py-3 bg-white/10 backdrop-blur-md">
                    <input
                      type="tel"
                      inputMode="numeric"
                      maxLength={10}
                      value={phoneNumber}
                      onChange={(e) => {
                        setPhoneNumber(e.target.value.replace(/\D/g, "").slice(0, 10));
                        setError("");
                      }}
                      className="w-full bg-transparent border-none text-white focus:outline-none placeholder-gray-300"
                      placeholder="Enter Phone number"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-white text-sm font-semibold mb-1">EMAIL</label>
                  <div className="border border-white rounded-xl px-4 py-3 bg-white/10 backdrop-blur-md">
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value.toLowerCase());
                        setError("");
                      }}
                      className="w-full bg-transparent border-none text-white focus:outline-none placeholder-gray-300"
                      placeholder="Enter email"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-white text-sm font-semibold mb-1">GROUP</label>
                  <div className="border border-white rounded-xl px-4 py-3 bg-white/10 backdrop-blur-md">
                    <select
                      value={group}
                      onChange={(e) => setGroup(e.target.value)}
                      className="w-full bg-transparent border-none text-white focus:outline-none placeholder-gray-300"
                    >
                      <option value="" disabled className="text-black">
                        Select a group
                      </option>
                      {groups.map((g) => (
                        <option key={g.group_id} value={g.group} className="text-black">
                          {g.group}
                        </option>
                      ))}
                    </select>
                  </div>
                  {groupsError && (
                    <p className="mt-1 text-xs font-semibold text-red-300">{groupsError}</p>
                  )}
                </div>

                <div>
                  <label className="block text-white text-sm font-semibold mb-1">PURPOSE</label>
                  <div className="border border-white rounded-xl px-4 py-3 bg-white/10 backdrop-blur-md">
                    <select
                      value={purpose}
                      onChange={(e) => setPurpose(e.target.value)}
                      className="w-full bg-transparent border-none text-white focus:outline-none placeholder-gray-300"
                    >
                      <option value="" disabled className="text-black">
                        Select purpose
                      </option>
                      <option value="part-time" className="text-black">Part-time</option>
                      <option value="full-time" className="text-black">Full-time</option>
                      <option value="influencer" className="text-black">Influencer</option>
                      <option value="contractor" className="text-black">Contractor</option>
                      <option value="intern" className="text-black">Intern</option>
                    </select>
                  </div>
                </div>

                <div>
                  <label className="block text-white text-sm font-semibold mb-1">
                    MAIN-APP EMPLOYEE CODE (optional)
                  </label>
                  <div className="border border-white rounded-xl px-4 py-3 bg-white/10 backdrop-blur-md">
                    <input
                      type="text"
                      value={mainEmployeeCode}
                      onChange={(e) => setMainEmployeeCode(e.target.value)}
                      className="w-full bg-transparent border-none text-white focus:outline-none placeholder-gray-300"
                      placeholder="Leave blank to auto-link by phone"
                    />
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-center mb-6">
                <p className="text-white text-lg font-bold text-center">
                  Onboarding/background verification fee
                </p>
              </div>

              <div className="flex items-center justify-center mb-4">
                <div className="w-44 h-20">
                  <input
                    type="number"
                    value={onboardingFee}
                    onChange={(e) => {
                      setOnboardingFee(e.target.value);
                      setError("");
                    }}
                    className="w-full h-full px-3 py-2 text-sm border-2 border-dashed border-red-500 rounded-lg focus:outline-none focus:ring-1 focus:ring-purple-500 bg-gray-400 placeholder:text-center placeholder:text-slate-50 text-white text-center"
                    placeholder="Amount"
                  />
                </div>
              </div>

              <div className="flex items-center justify-center mb-3 text-white text-lg font-bold">
                <FaChevronUp />
              </div>

              <button
                onClick={handleCreateAccount}
                disabled={submitting}
                className="w-full bg-green-500 border-2 border-white text-white font-bold py-3 px-4 rounded-lg transition duration-200 hover:bg-green-600 active:scale-95 disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {submitting ? "CREATING…" : "CREATE ACCOUNT"}
              </button>
            </div>
          </div>
        </div>
      )}

      {showConfirm && (
        <ConfirmModal onYes={handleConfirmYes} onNo={() => setShowConfirm(false)} />
      )}
    </>
  );
};

export default UserPopup;
